import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AppTheme } from "../../shared/theme";
import SessionBootstrap from "../bootstrap/SessionBootstrap";
import { AuthProvider } from "./AuthProvider";

export default function AppProviders({ children }) {
  return (
    <BrowserRouter future={{ v7_startTransition: true }}>
      <AuthProvider>
        <SessionBootstrap>
          <AppTheme>
            <Toaster
              reverseOrder
              toastOptions={{
                position: "bottom-left",
                style: { maxWidth: "100vw" },
                duration: 5000,
              }}
            />
            {children}
          </AppTheme>
        </SessionBootstrap>
      </AuthProvider>
    </BrowserRouter>
  );
}
